<template>
<div class="Christmas">
  <div class="title-sd"><em>༺❊</em>圣诞快乐<em>❊༻</em></div>
  <span class="sd sd1"></span>
  <span class="sd sd3"></span>
  <span class="sd sd2"></span>
  <video crossorigin="anonymous" autoplay preload="auto" loop playsinline webkit-playsinline="true" >
    <source src="../assets/yy.mp3" type="video/mp3" >
  </video>
</div>
</template>

<script>
export default {
  name: "demos"
}
</script>

<style scoped>
.Christmas{
  background: #E2393E url("../assets/sd1.gif") no-repeat center/100%;
  height: 100vh;
  width: 100%;
  position: relative;
}
.sd{
  display: inline-block;
  width: 620px;
  height: 620px;
  position: absolute;
}
.sd3{
  background: url("../assets/sd4.gif") no-repeat;
  right: 4.5%;
  top: 18%;
}
.sd1{
  background: url("../assets/sd2.gif") no-repeat center/100%;
  right: -5%;
  top: 20%;
  width: 410px;
  height: 510px;
}
.sd2{
  background: url("../assets/sd5.gif") no-repeat;
  right: 20.5%;
  top: 32%;
}
.title-sd{
  padding-right: 30px;
  font-size: 190px;
  font-weight: bold;
  position: relative;
  padding-top: 108px;
  z-index: 88;
  text-align: center;
  font-style:italic;
  letter-spacing:4px;
  width: 100%;
  background: linear-gradient(-49deg,#F4AA61,#FCEDC6,#F4AA61,#F4AA61,#FCEDC6,#EFAB60,#F4AA61,#FFD6B1 88%);
  transition: background-color 5s ease;
  -webkit-background-clip: text;
  color: transparent;
  animation: a6 .5s ease-out forwards;
  -webkit-text-stroke: 1px rgba(255,255,216,.6);
}
.title-sd em{
  font-style: normal;
  font-size: 90px;
}
</style>



// WEBPACK FOOTER //
// src/views/demos.vue